export const NAME = 'taskSearch';

export const dialogs = {
	tooManyResults: 'taskSearch/tooManyResults',
};

export const additionalTaskStatuses = {
	IN_TIME: 888,
	AFTER_DEADLINE: 999,
};

export const requiredFields = [
	'policyNumber',
	'taskType',
	'id',
	'surname',
	'personIn',
	'businessName',
	'businessIn',
	'login',
];

// FE to BE
export const relations = {
	policyNumber: 'policyNo',
	taskType: 'taskTypeId',
	taskSubTypeId: 'taskSubtypeId',
	id: 'id',
	statusId: 'statusId',
	finishTypeId: 'finishTypeId',
	surname: 'clientSurname',
	firstName: 'clientFirstname',
	personIn: 'clientPersonIn',
	businessName: 'businessName',
	businessIn: 'businessIn',
	municipality: 'clientCity',
	zipCode: 'clientZipCode',
	login: 'authorLogin',
	queueGroupCd: 'queueGroupCd',
	createdFrom: 'createdFrom',
	createdTo: 'createdTo',
};
